import AccountCompanyDetails from "@/components/modules/account/account-company-details";
import AccountEmployeeDetails from "@/components/modules/account/account-employee-details";
import AccountInviteEmployeeForm from "@/components/modules/account/account-invite-employee-form";
import { cn } from "@/lib/utils";

type AccountCompanyProps = {
  resolution: Resolution;
};

const AccountBusiness = ({ resolution }: AccountCompanyProps) => {
  return (
    <article className={cn("text-dark-primary flex-1/2 space-y-10")}>
      <AccountCompanyDetails locale={resolution.locale} />
      <AccountEmployeeDetails locale={resolution?.locale} />
      <AccountInviteEmployeeForm locale={resolution?.locale} />
    </article>
  );
};

export default AccountBusiness;
